import React from 'react';
import { Head, withRouteData } from 'react-static';

export default withRouteData(({ title, lang }) => (
  <Head
    htmlAttributes={{ lang }}
    title={title}
    link={[
      {
        rel: 'icon',
        href: '/favicon.ico',
      },
      {
        rel: 'icon',
        type: 'image/png',
        href: '/favicon-16x16.png',
        sizes: '16x16',
      },
      {
        rel: 'icon',
        type: 'image/png',
        href: '/favicon-32x32.png',
        sizes: '32x32',
      },
      {
        rel: 'shortcut icon',
        type: 'image/png',
        href: '/favicon-16x16.png',
      },
      {
        rel: 'apple-touch-icon',
        type: 'image/png',
        href: '/apple-touch-icon.png',
        sizes: '180x180',
      },
    ]}
  />
));



// WEBPACK FOOTER //
// /app/apps/ms/src/components/Head.js